import { useEffect, useMemo } from 'react';
import { useDataApi } from '@adsk/alloy-helpers';
import { useCurrentProjectId } from '@adsk/alloy-provider';
import { getConstructionApiUrl, ASSIGNABLE_PRODUCTS_MAP } from '@adsk/acs-admin-ui-components-helpers';

export default () => {
  const projectId = useCurrentProjectId();
  
  const buildGetProjectRequest = (projectId) => {  
    return `${getConstructionApiUrl()}/v1/projects/${projectId}`;
  };

  const {
    loading: isLoadingProjectData,
    data: project,
    doFetch: doGetProject,
  } = useDataApi();



  const products = useMemo(() => project?.products  || [], [project]);

  const assignableProducts = useMemo(
    () =>
      products
        .filter((product) => ASSIGNABLE_PRODUCTS_MAP[product.key] && product.status === 'active')
        .sort(({ name: a }, { name: b }) => a.localeCompare(b)),
    [products]
  );

  const productsMapByKey = useMemo(
    () =>
      products.reduce(
        (map, product) =>
          (ASSIGNABLE_PRODUCTS_MAP[product.key] && product.status === 'active')
            ? { ...map, [product.key]: product }
            : map,
        {}
      ),
    [products]
  );

  useEffect(() => {
    if (!projectId) return;

    doGetProject(buildGetProjectRequest(projectId));
  }, [
    projectId,
    doGetProject
  ]);

  return { data: assignableProducts, productsMapByKey, loading: isLoadingProjectData };
};
